import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "fw-bold text-dark" }
const _hoisted_4 = {
  class: "text-muted",
  style: {"font-size":"0.7rem"}
}
const _hoisted_5 = { class: "text-center text-nowrap small" }
const _hoisted_6 = { class: "text-truncate" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  key: 0,
  class: "badge bg-info"
}
const _hoisted_9 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = {
  key: 0,
  class: "fas fa-edit text-warning",
  title: "Mensaje editado"
}
const _hoisted_15 = {
  key: 1,
  class: "fas fa-trash text-danger",
  title: "Mensaje eliminado"
}
const _hoisted_16 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_17 = {
  key: 0,
  class: "bg-light"
}
const _hoisted_18 = {
  colspan: "6",
  class: "p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertDetails = _resolveComponent("AlertDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args))),
      style: {"cursor":"pointer"}
    }, [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass([
          'fas',
          _ctx.isExpanded ? 'fa-chevron-down' : 'fa-chevron-right',
          'fa-fw',
          'm-1',
          'text-secondary',
        ])
        }, null, 2)
      ]),
      _createElementVNode("td", {
        class: "text-center",
        style: {"vertical-align":"middle"},
        "aria-label": `Número de alerta ${_ctx.rowNumber}`
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.rowNumber), 1),
        _createElementVNode("div", _hoisted_4, "#" + _toDisplayString(_ctx.alert.mainMessage.messageId), 1)
      ], 8, _hoisted_2),
      _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formatDate(_ctx.alert.mainMessage.date)), 1),
      _createElementVNode("td", null, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.cleanAlertText(_ctx.getAlertSummary(_ctx.alert))), 1)
      ]),
      _createElementVNode("td", _hoisted_7, [
        (_ctx.alert.odds)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.alert.odds.toFixed(2)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
      ]),
      _createElementVNode("td", _hoisted_10, [
        (_ctx.alert.stake)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "badge",
              style: _normalizeStyle(_ctx.getStakeBadgeStyle(_ctx.alert.stake))
            }, _toDisplayString(_ctx.alert.stake), 5))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
      ]),
      _createElementVNode("td", _hoisted_12, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge", _ctx.getResultBadgeClass(_ctx.alert.resultStatus)])
        }, _toDisplayString(_ctx.getResultLabel(_ctx.alert.resultStatus)), 3)
      ]),
      _createElementVNode("td", _hoisted_13, [
        (_ctx.hasEditedMessages(_ctx.alert))
          ? (_openBlock(), _createElementBlock("i", _hoisted_14))
          : (_ctx.hasDeletedMessages(_ctx.alert))
            ? (_openBlock(), _createElementBlock("i", _hoisted_15))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
      ])
    ]),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
          _cache[5] || (_cache[5] = _createElementVNode("td", {
            colspan: "2",
            class: "bg-secondary bg-gradient",
            style: {"--bs-bg-opacity":"0.1"}
          }, null, -1)),
          _createElementVNode("td", _hoisted_18, [
            _createVNode(_component_AlertDetails, {
              alert: _ctx.alert,
              "is-editing": _ctx.isEditing,
              "is-saving": _ctx.isSaving,
              "is-reprocessing": _ctx.isReprocessing,
              "current-alert-type": "sports_betting",
              onStartEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('start-edit', $event))),
              onCancelEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel-edit'))),
              onSaveEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('save-edit', $event))),
              onReprocessMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reprocess-message', $event)))
            }, null, 8, ["alert", "is-editing", "is-saving", "is-reprocessing"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}